import { useQuery } from '@tanstack/react-query';
import { getUltimaExecucao } from '../services';

export const useUltimaExecucao = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['monitoramentos-ultima-execucao'],
    queryFn: getUltimaExecucao,
  });

  const lastUpdate = data?.data.ultimaExecucao ? new Date(data.data.ultimaExecucao).toLocaleDateString('pt-BR') : undefined;

  return { lastUpdate, isLoading };
};
